export default {
    install(_, options = {}) {
        const { router } = options;

        if (!router) {
            return;
        }

        const VueRouter = router.constructor;

        const originalPush = VueRouter.prototype.push;

        VueRouter.prototype.push = function(location, onComplete, onAbort) {
            // Переопределяем стандартный router.push расширяя его функционал.
            // В случае если возникает ошибка при навигации с роута на роут с идентичным параметрами, не берем ее в расчет.
            // В остальных случаях vue-router push работает в стандартном режиме.
            return originalPush.call(this, location)
                .then(onComplete)
                .catch(err => {
                    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
                        // Если это не NavigationDuplicated, NavigationCancelled, вызываем onAbort, если он определен
                        if (onAbort) {
                            onAbort(err);
                        }

                        return Promise.reject(err);
                    }

                    // если ошибок несколько, то Promise.resolve позволит продолжить цепочку вызовов,
                    // пропуская ошибку NavigationDuplicated, NavigationCancelled.
                    return Promise.resolve();
                });
        };
    },
};